export const getFormattedNumber = (number = "") => {
  const parsedValue = parseFloat(number);
  const isANumber = (parsedValue.toString() == number) && !isNaN(parsedValue);
  const valueToDisplay = isANumber ? NumberFormatter.format(parsedValue) : number;

  return { valueToDisplay, isANumber };
}